
import { CompanyMovementsTotalizerData } from "../types/companyMovementsTotalizer.type";

export const companyResumeItems = (data: CompanyMovementsTotalizerData) => {
  return [
    {
      label: "Consumido",
      value: data.consumed_total,
      textClassName: "text-yellow-400",
    },
    {
      label: "Total em descontos",
      value: data.discount_total || data.discounts_total,
    },
    {
      label: "Total em tarifas",
      value: data.fees_total,
    },
    {
      label: "Total de IR",
      value: data.income_tax_total,
    },
    {
      label: "Repasse",
      value: data.transfered_total,
    },
    {
      label: "Quant. Inadimplentes",
      value: data.due_bills_count?.toString(),
      textClassName: "text-yellow-400",
      isCurrencyValue: false
    },
    {
      label: "Valor Inadimplentes",
      value: data.due_bills_total,
      textClassName: "text-yellow-400",
    },
    {
      label: "Total Transacionado",
      value: data.transacted_total,
      textClassName: "text-yellow-400",
    },
    {
      label: "Demandam atenção",
      value: data.requires_attention_count,
      textClassName: "text-red-400",
      isCurrencyValue: false,
      showWhenRequireAttentionIsActive: true
    },
    {
      label: "Rentabilidade",
      value: data.profitability,
      textClassName: Number(data.profitability) < 0 ? 'text-red-400' : 'text-valid',
    },
  ];
};



